import { Button, ButtonMode, ButtonSize, Loader } from '@creditsights/styleguide-web';

import classNames from 'classnames/bind';
import { find, noop } from 'lodash';
import { ReactElement, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { Link } from 'react-router-dom';
import { USER_PROFILE_CACHE_KEY } from '../../../Constants';
import useFetchProfile from '../../../hooks/user/useFetchProfile';
import useFetchRoles from '../../../hooks/user/useFetchRoles';
import useSaveRole from '../../../hooks/user/useSaveRole';
import { OnboardingStepProps } from '../Onboarding';
import styles from './Role.module.scss';

const cx = classNames.bind(styles);

function Role({ onCancel, show, onContinue }: OnboardingStepProps): ReactElement | null {
  const queryClient = useQueryClient();
  const { data: user, isLoading: isProfileLoading } = useFetchProfile();
  const { data: roles, isLoading: isRolesLoading } = useFetchRoles();
  const { mutateAsync: saveRole } = useSaveRole();

  const [customRole, setCustomRole] = useState<string>('');
  const [selection, setSelection] = useState<any>({});

  useEffect(() => {
    if (user && roles?.length) {
      const text = user?.role?.freeText;

      if (text) {
        setCustomRole(text);
        setSelection(roles[roles.length - 1]);
      } else {
        setSelection(find(roles, { code: user?.role?.code }));
      }
    }
  }, [user, roles]);

  const save = async () => {
    let payload;
    if (selection.code !== null) {
      payload = {
        code: selection.code,
        freeText: null,
      };
    } else {
      payload = {
        code: null,
        freeText: customRole,
      };
    }
    return saveRole(payload, {
      onSuccess: () => {
        queryClient.invalidateQueries([USER_PROFILE_CACHE_KEY]);
      },
    });
  };

  if (!show) {
    return null;
  }
  if (!isProfileLoading && !isRolesLoading) {
    return (
      <div className={cx('body')}>
        <div className={cx('selection-ctx')}>
          <div className={cx('selections')}>
            {roles?.map((role, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={`role-${index}`} className={cx('selection')} onClick={() => setSelection(role)}>
                <div className="ui radio checkbox">
                  <input name="role" type="radio" checked={selection?.code === role.code} onChange={() => noop} />
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label>{role.label}</label>
                </div>
              </div>
            ))}
          </div>
          {selection?.code === null && (
            <div className={cx('custom-role-ctx')}>
              <div className={cx('selection-list-message')}>If Other, please enter your role here</div>
              <div className="ui fluid input">
                <input type="text" placeholder="Enter custom role" value={customRole} onChange={(e) => setCustomRole(e.currentTarget.value)} />
              </div>
            </div>
          )}
        </div>
        <div className={cx('footer')}>
          <div className={cx('contents')}>
            <Link to="/feed">
              <Button mode={ButtonMode.SECONDARY} size={ButtonSize.MEDIUM} onClick={onCancel}>
                Cancel
              </Button>
            </Link>
            <div className={cx('spacer')} />
            <Button mode={ButtonMode.PRIMARY} size={ButtonSize.MEDIUM} disabled={!customRole && !selection?.code} onClick={() => onContinue(save)}>
              Continue
            </Button>
          </div>
        </div>
      </div>
    );
  }
  return <Loader className="cs-loader" position="center" />;
}

export default Role;
